import produce from "immer";
import { LoadState } from "../../constants/enums";
import { initialAgentToolsState } from "./defaultState";
import { IAgentToolsState } from "./AgentTools.types";

export const agentToolsReducer = (
  state: IAgentToolsState = initialAgentToolsState,
  action: any
): IAgentToolsState => {
  switch (action.type) {
    case "FETCH_REGISTRY_LIST_PROGRESS":
      return produce(state, (d) => {
        d.registry.loading = LoadState.InProgress;
      });
    case "FETCH_REGISTRY_LIST_SUCCESS":
      return produce(state, (d) => {
        d.registry.loading = LoadState.Loaded;
        d.registry.data = action.payload.data;
      });
    case "FETCH_REGISTRY_LIST_FAILED":
      return produce(state, (d) => {
        d.registry.loading = LoadState.Failed;
      });
    case "FETCH_REGISTRY_MAPPINGS_PROGRESS":
      return produce(state, (d) => {
        d.mappings.loading = LoadState.InProgress;
      });
    case "FETCH_REGISTRY_MAPPINGS_SUCCESS":
      return produce(state, (d) => {
        d.mappings.loading = LoadState.Loaded;
        d.mappings.data = action.payload.data;
      });
    case "FETCH_REGISTRY_MAPPINGS_FAILED":
      return produce(state, (d) => {
        d.mappings.loading = LoadState.Failed;
      });
    case "CLEAR_AGENT_TOOLS_STATE":
      return initialAgentToolsState;
    default:
      return state;
  }
};
